import {
    selectDoc, selectArr,
    event, ajax, removeClassAll,
    toggleClass, addClassAll,
    hasClass, isVisible, addClass, removeClass
} from "../utils/utils";

import {addCartItemData, formatMoney, removeCartItem} from "../helpers/service.cart";
import {serialize, inputEmpty, showErrorPDPForm} from "../helpers/service.validator";
import {initSlider, initSliderPDP} from "../helpers/service.slider";
import {notify} from "../helpers/service.notification";
import {MiniCart} from "./component.minicart";
import {PDPSimple} from "./component.pdp-simple";

export class PDP {
    /**
     *
     * @param main
     * @param quickview
     */
    constructor(main, quickview = false) {
        this.initializer(main, quickview);
    }

    /**
     * Init PDP class properties
     * @param main
     * @param quickview
     */
    props(main, quickview) {
        this.html = selectDoc('html');
        this.body = selectDoc('body');
        this.pageContainer = selectDoc('#PageContainer');
        this.hiddenContainer = selectDoc('#pdp-hidden-container') ?? selectDoc('#pcp-hidden-container');
        this.setsHiddenContainer = selectDoc('#pdp-sets-hidden-container');

        this.productForm = selectDoc(main + ' form.shopify-product-form');
        this.isSimpleProduct = selectDoc(main + '.simple-product') ?? selectDoc(main + '.simple-gslb-product');
        this.type = selectDoc(main + ' #product-custom-data #product-type') ? selectDoc(main + ' #product-custom-data #product-type').value : '';
        this.handle = selectDoc(main + ' #product-custom-data #product-handle') ? selectDoc(main + ' #product-custom-data #product-handle').value : '';
        this.image = selectDoc(main + ' #product-custom-data #product-image') ? selectDoc(main + ' #product-custom-data #product-image').value : '';
        this.productSubCategory = selectDoc(main + ' #product-custom-data #product-sub-category');

        this.diamonds = [];
        this.diamond = selectDoc(main + ' #diamond');
        this.diamondClarity = selectDoc(main + ' #diamond-clarity');
        this.currentDiamondClarity = (main + ' #diamond-clarity input.selected');
        this.diamondCarat = selectDoc(main + ' #diamond-carat');
        this.currentDiamondCarat = (main + ' #diamond-carat input.selected');
        this.diamondSummary = selectDoc(main + ' #diamond .tab-summary label');
        this.diamondCodeInput = selectDoc(main + ' input[name="properties[diamond_code]"]');
        this.diamondSummaryInput = selectDoc(main + ' input[name="properties[diamond_summary]"]');

        this.metals = [];
        this.colorInterval = [];
        this.metal = selectDoc(main + ' #metal');
        this.metalGold = selectDoc(main + ' #metal-gold');
        this.currentMetalGold = (main + ' #metal-gold input.selected');
        this.metalColor = selectDoc(main + ' #metal-color');
        this.colorDisclaimer = selectDoc(main + ' #color-disclaimer');
        this.colorDisclaimerTAH = selectDoc(main + ' #metal-body .color-disclaimer');
        this.currentMetalColor = (main + ' #metal-color input.selected');
        this.currentGemstone = (main + ' #primarystone input.selected');
        this.metalSummary = selectDoc(main + ' #metal .tab-summary label');
        this.metalCodeInput = selectDoc(main + ' input[name="properties[metal_code]"]');
        this.metalSummaryInput = selectDoc(main + ' input[name="properties[metal_summary]"]');

        this.engrave = selectDoc(main + ' #engrave');
        this.engraveInput = selectDoc(main + ' #engraving');
        this.engraveChar = selectDoc(main + ' #engraving-char-counter');
        this.engraveFontsRadio = selectArr(main + ' #engrave .fonts .radio-row');
        this.engraveFonts = selectArr(main + ' #engrave .fonts input');
        this.currentFont = 'classic';

        this.size = selectDoc(main + ' #size');
        this.tabSize = selectDoc(main + ' #size.tab');
        this.sizeSummary = selectDoc(main + ' #size .tab-summary label');
        this.verlasCurrentSize = null;

        this.arrowButtons = selectArr(main + ' .tab-header.tab-arrow');
        this.tabs = selectArr(main + ' .tab-body');

        this.iframeAwsUrl = "https://d2zjrbs3h0xk1e.cloudfront.net";
        this.productIframe = selectDoc(main + ' #product3d');
        this.handIframe = selectDoc(main + ' #hand3d');
        this.iframeZoomFixed = false;

        this.sliderInitiated = false;
        this.handSlider = selectDoc(main + ' #slide-hand3d');
        this.productSlider = selectDoc(main + ' #slide-product3d');
        this.sliderImages = selectDoc(main + ' #slider #product-images-slider');
        this.viewOnHandSlider = selectDoc(main + ' .d3viewHand');
        this.slides = selectArr(main + ' #product-images-slider .glide__slides li');
        this.slidesControls = selectDoc(main + ' #product-images-slider .slider-controls');

        this.atcCtas = selectArr(main + ' button.atc');

        this.skinColor = selectDoc(main + ' #skin-color');
        this.skinColorBtns = selectArr(main + ' #skin-color button');

        this.verlasIsRing = false;
        this.ringOnly = selectArr(main + ' .ring-only');

        this.quickShop = selectDoc(main + ' #pdp-quickshop');
        this.qsViewProduct = selectArr(main + ' .viewProduct');
        this.quickShopImages = selectArr('#pdp-quickshop #image-qs img');
        this.qsIframe = selectDoc('#product3dIframe');
        this.gifthyIframe = selectDoc('#product3dgifthy');

        this.trueCostModule = selectDoc('#ws-pdp-formula');
        this.trueCostProps = [
            'raw_material_cost',
            'labor_cost',
            'duty_cost',
            'produce_cost', 'verlas_cost',
            'jeweler_cost', 'designer_cost'
        ];
        this.trueCostPropsValues = [
            'raw_material',
            'labor',
            'duty',
            'produce', 'price',
            'retailer', 'designer'
        ];

        this.dynamicModule = selectDoc(main + ' #ws-pdp-dynamic-specs');
        this.dynamicProps = [
            'total_carat_weight',
            'primary_diamond', 'primary_diamond_setting', 'primary_diamond_shape',
            'width_x_height',
            'secondary_diamond', 'secondary_diamond_setting', 'secondary_diamond_shape',
            'number_diamonds',
            'primary_gemstone_clarity', 'secondary_gemstone_clarity', 'secondary_gemstone_type', 'secondary_gemstone_weight'
        ]

        this.facebookShare = selectDoc(main + ' #toolbar .facebook-icon');
        this.facebookUrl = selectDoc(main + ' #toolbar .facebook-icon') ? selectDoc(main + ' #toolbar .facebook-icon').getAttribute('href') : null;
        this.emailShare = selectDoc(main + ' #toolbar .msg-icon');
        this.emailUrl = selectDoc(main + ' #toolbar .msg-icon') ? selectDoc(main + ' #toolbar .msg-icon').getAttribute('href') : null;

        this.urlCheked = false;
        this.main = main;
        this.isQuickView = quickview;
    }

    /**
     * Init PDP
     * @param main
     * @param quickview
     */
    initializer(main, quickview) {
        let self = this,
            init = performance.now();

        self.props(main, quickview);

        if (self.isSimpleProduct) {
            this.simpleComponent = new PDPSimple(self);
            this.simpleComponent.checkVariantUrl(self);
        } else {
            self.initVariants();
        }

        self.initQuickShop();
        self.initSkinColor();
        self.initGoBackButton();
        initSlider('.faq-slider', {
            type: 'carousel',
            perView: 1,
            rewindDuration: 0,
            peek: {
                before: 0,
                after: 0
            }
        });

        console.log("PDP took " + (performance.now() - init) + " milliseconds to load.")


        $('.pdp__yotpo-stars').on('click', () => {
          this.scrollToSection('#product-reviews', true);
        });

        // @ada
        $(".product-card .image").each(function () {
            $(this).focusin(function () {
                $(this).next('.quickview').css('opacity', '1');
                $(this).find('.content.active').next('.color-img-hover').addClass('with-focus');
            });
            $(this).focusout(function () {
                $(this).next('.quickview').css('opacity', '0');
                $(this).find('.content.active').next('.color-img-hover').removeClass('with-focus');
            });
        });

        $(".quickview").each(function () {
            $(this).focusin(function () {
                $(this).css('opacity', '1')
            });
            $(this).focusout(function () {
                $(this).css('opacity', '0')
            });
        });
    }

    getOffsetTop(el) {
      let offsetTop = 0;
      let element = el;

      while(element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
      }

      return offsetTop;
    }



    scrollToSection(anchor, animate) {
      const $section = anchor && anchor.includes('#') ? $(`${ anchor }`) : $(`#${ anchor }`);
      let top = this.getOffsetTop($section[0]);

      if (animate) {
        $('html').animate({
          scrollTop: top - 180
        }, 'slow');
      } else {
        window.scrollTo(0, top);
      }
    }

    /**
     * Check if valid URL
     * @param str
     * @returns {boolean}
     */
    validURL(str) {
        return str.match(/^(https?|ftp):\/\/[^\s\/$.?#].[^\s]*$/);
    }

    /**
     *
     * @param container
     * @param summary
     */
    updateSummary(container, summary) {
        let self = this;
        if (container) {
            if (self.isTAH()) {
                summary = summary
                    .replace(', TAH diamond', '')
                    .replace(', TAH', '')
                    .replace('TAH, ', 'Brass, ')
                    .replace(' gold', '');
            }
            container.innerHTML = summary
        }
    }

    /**
     * Fix iframe crazy zoom issue on touch devices
     * @param iframe
     */
    fixIframeZoom(iframe) {
        if (iframe) {
            iframe.onload = function () {
                if (/(iPad|iPhone)/g.test(navigator.userAgent)) {
                    iframe.setAttribute('scrolling', 'no');
                }
            }
        }
    }

    /**
     * Update 3D render iframes
     * @param diamond
     * @param message
     * @param type
     */
    updateIFrames(diamond, message = null, type = null) {
        let self = this;
        if (self.sliderInitiated) {
            if (diamond) {
                /**
                 * Change hand iframe source
                 */
                if (self.handIframe) {
                    if (self.handIframe.src != diamond['3d_hand_image']) {
                        if (inputEmpty(diamond['3d_hand_image']) || !diamond['3d_hand_image'] || !self.validURL(diamond['3d_hand_image'])) {
                            if (self.handSlider.parentNode) {
                                self.handSlider.parentNode.removeChild(self.handSlider);
                            }
                        } else {
                            self.handIframe.src = diamond['3d_hand_image']
                        }
                    }
                }

                /**
                 * Change product iframe source
                 */
                if (self.productIframe) {
                    if (self.productIframe.src != diamond['3d_product_image']) {
                        if (
                            inputEmpty(diamond['3d_product_image']) ||
                            !diamond['3d_product_image'] ||
                            !self.validURL(diamond['3d_product_image'])
                        ) {
                            if (self.productSlider.parentNode) {
                                self.productSlider.parentNode.removeChild(self.productSlider);
                            }
                        } else {
                            self.productIframe.src = diamond['3d_product_image']
                            if (self.qsIframe) {
                                self.qsIframe.src = diamond['3d_product_image']
                            }
                            if (self.gifthyIframe) {
                                self.gifthyIframe.src = diamond['3d_product_image']
                            }

                            /**
                             * Apply metal/hand color to current iframes
                             */
                            self.colorInterval.map(interval => {
                                clearInterval(interval);
                            })

                            let intervalRepetitions = 0;
                            self.colorInterval.push(setInterval(function () {
                                intervalRepetitions++;
                                if (intervalRepetitions > 4) {
                                    self.colorInterval.map(interval => {
                                        clearInterval(interval);
                                    })
                                }
                                let currentVariant = self.isSimpleProduct ? self.simpleComponent.getCurrentVariantDynamic(false, self) : self.getCurrentVariant();
                                if (currentVariant) {
                                    let awsColorText = '',
                                        awsGemText = '',
                                        fcolor,
                                        fmetal;

                                    if (self.isSimpleProduct) {
                                        fmetal = currentVariant.metal;
                                        fcolor = selectDoc(self.main + ' #metal-color input.selected');
                                        if (fcolor) {
                                            fcolor = fcolor.getAttribute('data-v').replaceAll('-gold', '');
                                        }
                                    } else {
                                        if (currentVariant.metal && currentVariant.diamond) {
                                            fmetal = currentVariant.diamond.metal;
                                            fcolor = currentVariant.metal.value.replace('-gold', '');
                                        }
                                    }

                                    if (self.isPlatinum(fmetal)) {
                                        awsColorText = 'Platinum';
                                    } else {
                                        awsColorText += fmetal ? `${fmetal.charAt(0).toUpperCase()}${fmetal.substr(1).toLowerCase()}` : '';
                                        awsColorText += fcolor ? `${fcolor.charAt(0).toUpperCase()}${fcolor.substr(1)}_Gold` : '';
                                    }

                                    let fgem = selectDoc(self.main + ' #primarystone input.selected');
                                    if (fgem) {
                                        fgem = fgem.getAttribute('data-target');
                                        fgem = `${fgem.charAt(0).toUpperCase()}${fgem.substr(1).toLowerCase()}`;
                                        if (fgem.includes('sapphire')) {
                                            fgem = 'Sapphire';
                                        }
                                        if (fgem.includes('topaz')) {
                                            fgem = 'Topaz';
                                        }
                                        awsGemText += `Gem_Center_${fgem}`;
                                    }

                                    //Product color
                                    self.updateIFrames(null, awsColorText, 'both')
                                    self.updateIFrames(null, awsGemText, 'both')

                                    //Hand color
                                    if (selectDoc(self.main + ' #skin-color button.active')) {
                                        self.updateIFrames(null, selectDoc(self.main + ' #skin-color button.active').id, 'hand')
                                    }
                                }
                            }, 1000));
                        }
                    }
                }
            }

            if (message) {
                /**
                 * Try-at-home validation
                 */
                message = message.replace('Tah', '14k')
                switch (type) {
                    case 'product':
                        if (self.productIframe) {
                            if (self.productIframe.contentWindow) {
                                self.productIframe.contentWindow.postMessage(message, self.iframeAwsUrl)
                                if (self.qsIframe) {
                                    self.qsIframe.contentWindow.postMessage(message, self.iframeAwsUrl)
                                }
                                if (self.gifthyIframe) {
                                    self.gifthyIframe.contentWindow.postMessage(message, self.iframeAwsUrl)
                                }
                            }
                        }
                        break;
                    case 'hand':
                        if (self.handIframe) {
                            if (self.handIframe.contentWindow) {
                                self.handIframe.contentWindow.postMessage(message, self.iframeAwsUrl)
                            }
                        }
                        break;
                    case 'both':
                        if (self.productIframe) {
                            if (self.productIframe.contentWindow) {
                                self.productIframe.contentWindow.postMessage(message, self.iframeAwsUrl)
                                if (self.qsIframe) {
                                    self.qsIframe.contentWindow.postMessage(message, self.iframeAwsUrl)
                                }
                                if (self.gifthyIframe) {
                                    self.gifthyIframe.contentWindow.postMessage(message, self.iframeAwsUrl)
                                }
                            }
                        }
                        if (self.handIframe) {
                            if (self.handIframe.contentWindow) {
                                self.handIframe.contentWindow.postMessage(message, self.iframeAwsUrl)
                            }
                        }
                        break;
                    default:
                        break;
                }
            }

            /**
             * Fix zoom issue
             */
            if (!self.iframeZoomFixed) {
                self.fixIframeZoom(self.qsIframe);
                self.fixIframeZoom(self.gifthyIframe);
                self.fixIframeZoom(self.handIframe);
                self.fixIframeZoom(self.productIframe);
                self.iframeZoomFixed = true;
            }
        }
    }

    /**
     * Get actual selected variant
     * @returns {{diamond: T, metal: T}|null}
     */
    getCurrentVariant() {
        let self = this;
        /**
         * Diamond
         */
        let currentClarity = selectDoc(self.currentDiamondClarity),
            currentCarat = selectDoc(self.currentDiamondCarat);

        /**
         * Metal
         */
        let currentGold = selectDoc(self.currentMetalGold),
            currentColor = selectDoc(self.currentMetalColor);

        /**
         * Switch Current Variant
         */
        if (currentClarity && currentCarat && currentGold && currentColor) {
            let clarity = currentClarity.getAttribute('data-v'),
                gold = currentGold.getAttribute('data-v'),
                size = currentCarat.getAttribute('data-v'),
                color = currentColor.getAttribute('data-v');

            /**
             * Check availability
             */
            selectArr(self.main + ' #diamond-carat input.variant').map(carat => {
                let caratValue = carat.getAttribute('data-v'),
                    caratFound = false;
                selectArr(self.main + ' #metal-gold input.variant').map(gold => {
                    let goldValue = gold.getAttribute('data-v')
                    if (self.diamonds.find(diamond => diamond.value === `${clarity}/${caratValue}/${goldValue}`)) {
                        caratFound = true
                    }
                })
                if (!caratFound) {
                    addClass(carat, 'hide')
                    removeClass(carat, 'selected')
                    removeClass(carat.parentNode.parentNode, 'selected')
                } else {
                    removeClass(carat, 'hide')
                }
            })

            selectArr(self.main + ' #metal-gold input.variant').map(gold => {
                let goldValue = gold.getAttribute('data-v')
                if (!self.diamonds.find(diamond => diamond.value === `${clarity}/${size}/${goldValue}`)) {
                    addClass(gold, 'hide')
                    removeClass(gold, 'selected')
                    removeClass(gold.parentNode.parentNode, 'selected')
                } else {
                    removeClass(gold, 'hide')
                }
            })

            /**
             * Reload variant data values
             */
            currentClarity = selectDoc(self.currentDiamondClarity);
            currentCarat = selectDoc(self.currentDiamondCarat);
            currentGold = selectDoc(self.currentMetalGold);
            currentColor = selectDoc(self.currentMetalColor);

            clarity = currentClarity.getAttribute('data-v');
            gold = currentGold.getAttribute('data-v');
            size = currentCarat.getAttribute('data-v');
            color = currentColor.getAttribute('data-v');

            return {
                'diamond': self.diamonds.find(diamond => diamond.value === `${clarity}/${size}/${gold}`),
                'metal': self.metals.find(metal => metal.value === `${color}`)
            }
        }

        return null;
    }

    /**
     * Process variants data
     * @returns {Promise<void>}
     */
    initVariants() {
        let self = this;
        try {
            let productDataVariants = selectArr(self.main + ' #product-custom-data data'),
                productData = {
                    "product_type": self.type,
                    "sub_category": self.productSubCategory ? self.productSubCategory.value.toUpperCase() : '',
                    "diamonds": [],
                    "color": [
                        {
                            "value": "white-gold"
                        },
                        {
                            "value": "yellow-gold"
                        },
                        {
                            "value": "rose-gold"
                        }
                    ]
                };

            productDataVariants.map(productVariant => {
                let verlasFields = JSON.parse(productVariant.value.replace(/=>/g, ':'));
                productData.diamonds.push({
                    "variant": productVariant.getAttribute('data-id'),

                    "clarity": verlasFields.clarity,
                    "weight": verlasFields.carat,
                    "metal": verlasFields.metal,

                    "3d_product_image": verlasFields.product_aws ? verlasFields.product_aws.trim() : null,
                    "3d_hand_image": verlasFields.hand_aws ? verlasFields.hand_aws.trim() : null,

                    "raw_material": verlasFields.raw_materials_cost,
                    "labor": verlasFields.labor_cost,
                    "duty": verlasFields.warehouse_cost,
                    "retailer": verlasFields.retailer_price,
                    "designer": verlasFields.designer_price,
                    "margin": verlasFields.margin,
                    "total": verlasFields.verlas_price,

                    "total_carat_weight": verlasFields.total_carat_weight,
                    "primary_diamond": verlasFields.primary_diamond,
                    "primary_diamond_setting": verlasFields.primary_diamond_setting,
                    "primary_diamond_shape": verlasFields.primary_diamond_shape,
                    "secondary_diamond": verlasFields.secondary_diamond,
                    "secondary_diamond_setting": verlasFields.secondary_diamond_setting,
                    "secondary_diamond_shape": verlasFields.secondary_diamond_shape,
                    "width_x_height": verlasFields.width_x_height,
                    "number_diamonds": verlasFields.secondary_diamonds,
                    "primary_gemstone_clarity": verlasFields.primary_gemstone_clarity,
                    "secondary_gemstone_clarity": verlasFields.secondary_gemstone_clarity,
                    "secondary_gemstone_type": verlasFields.secondary_gemstone_type,
                    "secondary_gemstone_weight": verlasFields.secondary_gemstone_weight
                })
            });

            //Sort  by total price
            productData.diamonds.sort(function (a, b) {
                let priceA = parseInt(a.total),
                    priceB = parseInt(b.total);

                if (priceA < priceB) {
                    return -1;
                } else if (priceA > priceB) {
                    return 1;
                } else {
                    return 0;
                }
            });
            if (productData.diamonds.length > 0) {
                let diamonds = [],
                    metals = [],
                    golds = [];

                /**
                 * Extract and sort variants
                 */
                productData.diamonds.forEach(function (diamond) {
                    diamonds.push({
                        first: diamond.clarity,
                        second: diamond.weight
                    });
                    golds.push({
                        type: diamond.metal
                    });
                    diamond.value = `${diamond.clarity}/${diamond.weight}/${diamond.metal}`
                })
                productData.color.forEach(function (color) {
                    golds.map(gold => {
                        metals.push({
                            first: color.value,
                            second: gold.type
                        });
                    })
                })

                if (self.isTAH()) {
                    if (productData.sub_category.includes('RING') && !productData.sub_category.includes('EARRING')) {
                        self.verlasIsRing = true;
                        addClass(self.body, 'is-ring-page')
                    }
                } else {
                    if (productData.product_type.includes('Ring') && !productData.product_type.includes('Earring')) {
                        self.verlasIsRing = true;
                        addClass(self.body, 'is-ring-page')
                    }
                }

                if (self.verlasIsRing) {
                    if (self.colorDisclaimerTAH) {
                        self.colorDisclaimerTAH.parentNode.removeChild(self.colorDisclaimerTAH)
                    }

                    if (self.viewOnHandSlider) {
                        self.viewOnHandSlider.classList.add('show')
                    }

                    if (self.tabSize) {
                        self.tabSize.classList.add('show')
                    }

                    if (self.engrave) {
                        addClass(self.engrave, 'show')
                    }
                } else {
                    /**
                     * Remove hand view
                     */
                    if (self.handSlider) {
                        self.handIframe = null;
                        self.handSlider.parentNode.removeChild(self.handSlider)
                    }

                    if (self.engrave) {
                        self.engrave.parentNode.removeChild(self.engrave)
                    }

                    self.ringOnly.map(only => {
                        only.parentNode.removeChild(only)
                    })
                }

                self.qsViewProduct.map(viewProduct => {
                    viewProduct.innerText += ` ${self.isTAH() ? self.productSubCategory.value.replace('tah-', '') : self.type}`
                })

                /**
                 * Diamond variants
                 */
                let diamondClarity = [],
                    diamondCaratWeight = [];
                self.extractVariants(diamonds, diamondClarity, diamondCaratWeight)
                self.injectVariants(self.diamondClarity, diamondClarity, 'diamond-clarity')
                self.injectVariants(self.diamondCarat, diamondCaratWeight, 'diamond-carat')
                self.updateSummary(self.diamondSummary, '')

                if (diamondClarity.length > 0 && diamondCaratWeight.length > 0) {
                    if (diamondClarity[0] !== "0" && diamondCaratWeight[0] !== "0") {
                        addClass(self.diamond, 'show')
                    }
                }
                self.diamonds = productData.diamonds;

                /**
                 * Metal variants
                 */
                let metalGold = [],
                    metaColor = [];
                self.extractVariants(metals, metaColor, metalGold)
                self.injectVariants(self.metalGold, metalGold, 'metal-gold')
                self.injectVariants(self.metalColor, metaColor, 'metal-color')
                self.updateSummary(self.metalSummary, '')
                if (metalGold.length > 0 && metaColor.length > 0) {
                    if (metalGold[0] !== "0" && metaColor[0] !== "0") {
                        addClass(self.metal, 'show')
                    }
                }
                self.metals = productData.color;

                /**
                 * Visible steps number
                 */
                selectArr(self.main + ' .tabs .tab.show .tab-number label').map((number, index) => {
                    number.innerHTML = (index + 1);
                })

                /**
                 * Other
                 */
                self.initSizeTab();
                self.processVariants();
                self.initEngraving();
                self.initTabSystem();
                self.showVariantData();
                self.initAddToCart();
            }
        } catch (e) {
            console.log('Error fetching regular product data.', e)
        }
    }

    /**
     * Extract variants information
     * @param options
     * @param acum1
     * @param acum2
     */
    extractVariants(options, acum1, acum2) {
        options.forEach((option) => {
            if (!acum1.includes(option.first)) {
                acum1.push(option.first)
            }
            if (!acum2.includes(option.second)) {
                acum2.push(option.second)
            }
        })
    }

    /**
     * Inject variants on frontend
     * @param container
     * @param variants
     * @param type
     */
    injectVariants(container, variants, type) {
        variants.forEach(variant => {
            if (variant) {
                let rClass = `${variant.replace('-gold', '')}`,
                    vClass = ` ${variant.replace('-gold', '')} variant`,
                    vLabel = variant.replace('-', ' ').replace('gold', '');
                container.innerHTML += `<div class="radio-row ${rClass}" data-type='${type}' tabindex='0'>
                                            <div class="radio-wrapper">
                                              <input class='${vClass}' data-v='${variant}' data-type='${type}' type="radio" name="${type}" id="radio-${variant}"/>
                                              <span aria-hidden="true"></span>
                                            </div>
                                            <label for="radio-${variant}">${vLabel}</label>
                                         </div>`;
            }
        })
    }

    /**
     * Set up variants events
     * @returns {Promise<void>}
     */
    processVariants() {
        let self = this;
        selectArr(self.main + ' .variant').map(variant => {
            event(variant, 'click', function (e) {
                //e.preventDefault();

                removeClassAll(selectArr(self.main + ` input[data-type="${variant.getAttribute('data-type')}"]`), 'selected');
                removeClassAll(selectArr(self.main + ` div[data-type="${variant.getAttribute('data-type')}"].radio-row`), 'selected');
                toggleClass(variant, 'selected');
                toggleClass(variant.parentNode.parentNode, 'selected');

                if (self.isSimpleProduct) {
                    self.simpleComponent.processVariant(variant, self);
                    self.simpleComponent.showVariantData(self)
                } else {
                    /**
                     * Switch Current Variant
                     */
                    let currentVariant = self.getCurrentVariant();
                    if (currentVariant) {
                        /**
                         * Update tabs summary
                         */
                        let currentClarity = ', ' + selectDoc(self.currentDiamondClarity).getAttribute('data-v') + ' diamond',
                            currentCarat = selectDoc(self.currentDiamondCarat).getAttribute('data-v'),
                            currentGold = selectDoc(self.currentMetalGold).getAttribute('data-v').replace('-', ' '),
                            currentColor = ', ' + selectDoc(self.currentMetalColor).getAttribute('data-v').replace('-', ' ');

                        if (self.isPlatinum(currentGold)) {
                            currentColor = '';
                            if (self.colorDisclaimer) {
                                self.colorDisclaimer.classList.add('show')
                                self.metalColor.classList.add('hide')
                            }
                        } else {
                            if (self.colorDisclaimer) {
                                self.colorDisclaimer.classList.remove('show')
                                self.metalColor.classList.remove('hide')
                            }
                        }

                        if (self.isTAH()) {
                            currentClarity = '';
                            currentGold = 'Brass';
                        }
                        self.updateSummary(self.diamondSummary, `${currentCarat}${currentClarity}`)
                        self.updateSummary(self.metalSummary, `${currentGold}${currentColor}`)

                        if (currentVariant.metal && currentVariant.diamond) {
                            /**
                             * Update iframes
                             */
                            let fmetal = currentVariant.diamond.metal,
                                awsColorText = '',
                                quickShopColor = currentVariant.metal.value.replace('-gold', '');

                            if (self.isPlatinum(fmetal)) {
                                awsColorText = 'Platinum';
                                quickShopColor = ''
                            } else {
                                let fcolor = currentVariant.metal.value.replace('-gold', '')
                                awsColorText += fmetal ? `${fmetal.charAt(0).toUpperCase()}${fmetal.substr(1).toLowerCase()}` : '';
                                awsColorText += fcolor ? `${fcolor.charAt(0).toUpperCase()}${fcolor.substr(1)}_Gold` : '';
                            }

                            self.sliderInitiated ? self.updateIFrames(currentVariant.diamond, awsColorText, 'both') : ''

                            self.updateQuickShopImage(quickShopColor)

                            /**
                             * Update metal & diamond inputs
                             */
                            self.metalSummaryInput.value = self.metalSummary.innerText
                            self.metalCodeInput.value = self.isTAH() ? currentVariant.metal.value.replace('-gold', '') : currentVariant.metal.value;
                            self.diamondSummaryInput.value = self.diamondSummary.innerText

                            if (self.isTAH()) {
                                try {
                                    let caratSku = currentVariant.diamond['3d_product_image'].split('/');
                                    caratSku = caratSku[(caratSku.length - 2)];
                                    self.diamondCodeInput.value = caratSku + 'TAH';
                                } catch (e) {
                                    self.diamondCodeInput.value = currentVariant.diamond.variant + 'TAH';
                                }
                            } else {
                                self.diamondCodeInput.value = currentVariant.diamond.variant;
                            }

                            self.showVariantData()
                        }
                    }
                }
            })
        })
    }

    /**
     * Engraving events
     * @returns {Promise<void>}
     */
    initEngraving() {
        let self = this;
        if (self.engrave) {
            self.engraveFonts.map(font => {
                event(font, 'click', function (e) {

                    removeClassAll(self.engraveFonts, 'selected');
                    removeClassAll(self.engraveFontsRadio, 'selected');

                    toggleClass(font, 'selected');
                    toggleClass(font.parentNode.parentNode, 'selected');

                    self.engraveInput.className = ''
                    self.engraveInput.classList.add(font.id)
                    switch (font.id) {
                        case 'philosopher':
                            self.currentFont = 'classic'
                            break
                        case 'allura':
                            self.currentFont = 'cursive'
                            break
                        case 'roboto':
                            self.currentFont = 'modern'
                            break;
                    }

                    self.updateIFrames(null, `Engrave_${self.engraveInput.value}_${self.currentFont}`, 'product')
                })
            })

            event(self.engraveInput, 'input', function () {
                let length = self.engraveInput.value.length
                self.engraveChar.innerHTML = length + '/18'
                self.updateIFrames(null, `Engrave_${self.engraveInput.value}_${self.currentFont}`, 'product')
            })
        }
    }

    /**
     * Tabs dynamic css height
     */
    reHeight() {
        let self = this;
        selectArr(self.main + ' .tab-body').map(container => {
            let divs = selectArr(self.main + ` #${container.id} > div`),
                fieldsets = selectArr(self.main + ` #${container.id} > fieldset`),
                height = 0;

            divs.map(content => {
                if (isVisible(content)) {
                    height += content.getBoundingClientRect().height
                    let contentStyle = content.currentStyle || window.getComputedStyle(content),
                        marginTop = contentStyle.marginTop.replace('px', '');
                    height += parseInt(marginTop)
                }
            });

            fieldsets.map(content => {
                if (isVisible(content)) {
                    height += content.getBoundingClientRect().height
                    let contentStyle = content.currentStyle || window.getComputedStyle(content),
                        marginTop = contentStyle.marginTop.replace('px', '');
                    height += parseInt(marginTop)
                }
            });

            container.style.height = (height) + 'px';
        })
    }

    /**
     * Tabs system events
     * @returns {Promise<void>}
     */
    initTabSystem() {
        let self = this;

        const openTab = (button) => {
            let currentTab = selectDoc(self.main + ' #' + button.getAttribute('data-target'));

            if (hasClass(currentTab, 'close')) {
                addClassAll(self.tabs, 'close')
                removeClass(self.arrowButtons, 'open')
                //ADA
                self.tabs.map(tb => {
                    tb.setAttribute('aria-hidden', 'true')
                });
                self.arrowButtons.map(ab => {
                    ab.setAttribute('aria-expanded', 'false')
                });
            }

            toggleClass(currentTab, 'close');
            toggleClass(button, 'open');

            //ADA
            if (!hasClass(currentTab, 'close')) {
                currentTab.setAttribute('aria-hidden', 'false');
                button.setAttribute('aria-expanded', 'true');
            }
        }

        self.arrowButtons.map(button => {
            ['mousedown',  'focus'].map(ev => {
                event(button, ev, function (e) {
                    openTab(button);
                    if(ev === 'mousedown') {
                        e.preventDefault();
                    }
                });
            });
        })

        self.reHeight();
        event(window, 'resize', self.reHeight)
    }

    /**
     * Size dropdown options and events
     * @returns {Promise<void>}
     */
    initSizeTab() {
        let self = this;
        let sizeOpts = selectArr(self.main + ' #size-body .size-opt'),
            sizeOptsRadios = selectArr(self.main + ' #size-body .radio-row');
        sizeOpts.map((opt, index) => {
            let self = this;
            event(opt, 'click', function (e) {
                let optLabel = selectDoc('label', opt.parentNode.parentNode)

                removeClassAll(sizeOptsRadios, 'selected')
                removeClassAll(sizeOpts, 'selected')

                self.tabSize ? self.tabSize.classList.remove('error') : ''
                self.updateSummary(self.sizeSummary, `${optLabel.innerText.replace('(made to order)', '').replace('(in stock)', '')}`)
                self.showVariantData(opt, index);

                addClass(opt, 'selected')
                addClass(opt.parentNode.parentNode, 'selected')
            })
        })
    }

    /**
     * Add to cart method
     * @returns {Promise<void>}
     */
    initAddToCart() {
        let self = this;
        if (self.atcCtas) {
            self.atcCtas.map(atcCta => {
                if (self.isTAH()) {
                    self.initAddToTah(atcCta)
                } else {
                    if (!self.addingtoCart && atcCta) {
                        event(atcCta, 'click', function (e) {
                            e.preventDefault()
                            let setPiecesSummary = null;
                            let form = selectDoc(self.main + ' form.shopify-product-form'),
                                formData = serialize(form);

                            if (self.isSimpleProduct) {
                                //validate band size selected...if applies..
                                let sizeTabValidate = selectDoc(self.main + ' .tab.show#size');
                                if (sizeTabValidate) {
                                    if (!selectDoc(self.main + ' .tab.show#size .tab-body input.selected')) {
                                        let sizeTab = selectDoc(self.main + ' [data-target="size-body"]')
                                        if (sizeTab) {
                                            showErrorPDPForm(atcCta, 'Please select a band size')
                                            sizeTab.click()
                                        }
                                        if (self.productForm) {
                                            self.productForm.scrollIntoView();
                                        }
                                        return;
                                    }
                                }

                                let selectedVariant = self.verlasCurrentSize;
                                if (selectedVariant) {
                                    formData.id = selectedVariant.value;

                                    //Summary
                                    formData.properties.summary = '';
                                    selectArr(self.main + ' .tab.show').map((tab, i) => {
                                        let summary = selectDoc(self.main + ' .tab-summary label', tab);
                                        if (summary) {
                                            let summaryAdded = false;
                                            switch (tab.id) {
                                                case "size":
                                                    summaryAdded = true;
                                                    formData.properties.summary += (i > 0 ? ' | ' : ' ');
                                                    formData.properties.band_size = summary.innerText;
                                                    break;
                                                case "metal":
                                                    summaryAdded = true;
                                                    formData.properties.summary += (i > 0 ? ' | ' : ' ');
                                                    let metalColor = selectDoc(self.main + ' #metal-color input.selected', tab)
                                                    formData.properties.metal_code += metalColor ? metalColor.getAttribute('data-v') : '';
                                                    break;
                                            }

                                            if(tab.id.includes('setmetalcolor')) {
                                                summaryAdded = true;
                                                if(!summary.getAttribute('data-summary')) {
                                                    setPiecesSummary = summary.innerText;
                                                } else {
                                                    if(!setPiecesSummary) {
                                                        setPiecesSummary = [];
                                                    }
                                                    setPiecesSummary.push(`${summary.getAttribute('data-summary')}: ${summary.innerText}`);
                                                }
                                            }

                                            if(!summaryAdded) {
                                                formData.properties.summary += (i > 0 ? ' | ' : ' ');
                                                if (summary.getAttribute('data-summary')) {
                                                    formData.properties.summary += `${summary.getAttribute('data-summary')}: ${summary.innerText}`
                                                } else {
                                                    formData.properties.summary += summary.innerText
                                                }
                                            }
                                        }
                                    })
                                    formData.properties.summary = formData.properties.summary.trim();
                                }
                            } else {
                                if (self.verlasCurrentSize) {
                                    formData.id = self.verlasCurrentSize.getAttribute('data-id');
                                    formData.properties.band_size_code = self.verlasCurrentSize.getAttribute('data-sku')
                                    formData.properties.band_size = self.verlasCurrentSize.getAttribute('data-title')
                                }

                                //Validate required inputs for complex products
                                if (
                                    inputEmpty(formData.properties['diamond_code']) ||
                                    inputEmpty(formData.properties['metal_code']) ||
                                    (inputEmpty(formData.properties['band_size']) && self.verlasIsRing)
                                ) {
                                    let sizeTab = selectDoc(self.main + ' [data-target="size-body"]')
                                    if (sizeTab) {
                                        showErrorPDPForm(atcCta, 'Please select a band size')
                                        sizeTab.click()
                                    }
                                    if (self.productForm) {
                                        self.productForm.scrollIntoView();
                                    }
                                    return;
                                }

                                //Extra properties
                                self.handle && formData.properties ? formData.properties.master = self.handle : '';
                                self.image && formData.properties ? formData.properties.master_img = self.image : '';
                            }

                            //Sets
                            if (selectDoc('.product-sets .product button.quickview') && !selectDoc('.modal-container.active')) {
                                selectDoc('.product-sets .product button.quickview').click();
                                return;
                            }

                            if(selectDoc('#set-products')) {
                                let setPieces = 0;
                                formData.properties['isSet'] = true;
                                formData.properties['pieces'] = '';
                                selectArr('#set-details .set-piece').map(piece => {
                                    formData.properties['pieces'] += `${piece.getAttribute('data-title')}|${piece.getAttribute('data-id')}|${piece.getAttribute('data-price')},`;
                                    formData.properties.summary += (setPieces > 0 ? ' | ' : ' ');
                                    if(Array.isArray(setPiecesSummary)) {
                                        let pieceSummary = setPiecesSummary[setPieces];
                                        setPieces++;
                                        formData.properties.summary += `${setPieces}. ${pieceSummary}`
                                    } else {
                                        setPieces++;
                                        formData.properties.summary += `${setPieces}. ${piece.getAttribute('data-title')}: ${setPiecesSummary}`;
                                    }
                                });
                            }

                            self.addingtoCart = true;
                            atcCta.classList.add('atc--inactive');

                            new Promise(resolve => {
                                //GTM
                                if (typeof dataLayer != 'undefined') {
                                    dataLayer.push({
                                        'event': 'add-to-cart',
                                        'category': 'click',
                                        'product': {
                                            'name': selectDoc('.pdp-title').innerText,
                                            'id': formData.id,
                                            'price': selectDoc('#addToCart .pdp-price').innerText,
                                            'quantity': 1,
                                        }
                                    });
                                }
                                ajax('POST', "/cart/add.js", JSON.stringify(formData))
                                    .then(function (response) {
                                        resolve(response);
                                    });
                            }).then(
                                function (response) {
                                    response = JSON.parse(response);
                                    if (response.status === 200) {
                                        self.addingtoCart = false;
                                        atcCta.classList.remove('atc--inactive');
                                        MiniCart.redirect()
                                    } else {
                                        console.log('Error adding to cart!');
                                    }
                                })
                        })
                    }
                }
            })
        }
    }

    /**
     * Show current variant data
     */
    showVariantData(size = null, pos = 0) {
        let self = this;
        if (!self.getCurrentVariant()) {
            if (!self.checkVariantUrl()) {
                if (!selectDoc(self.currentDiamondClarity)) {
                    let firstClarity = selectDoc(self.main + ' #diamond-clarity input:not(.hide)')
                    firstClarity ? addClass(firstClarity, 'selected') : ''
                    firstClarity ? addClass(firstClarity.parentNode.parentNode, 'selected') : ''
                    firstClarity ? firstClarity.click() : '';
                }

                if (!selectDoc(self.currentDiamondCarat)) {
                    let firstCarat = selectDoc(self.main + ' #diamond-carat input:not(.hide)')
                    firstCarat ? addClass(firstCarat, 'selected') : ''
                    firstCarat ? addClass(firstCarat.parentNode.parentNode, 'selected') : ''
                    firstCarat ? firstCarat.click() : '';
                }

                if (!selectDoc(self.currentMetalGold)) {
                    let firstGold = selectDoc(self.main + ' #metal-gold input:not(.hide)')
                    firstGold ? addClass(firstGold, 'selected') : ''
                    firstGold ? addClass(firstGold.parentNode.parentNode, 'selected') : ''
                    firstGold ? firstGold.click() : '';
                }

                if (!selectDoc(self.currentMetalColor)) {
                    let firstColor = selectDoc(self.main + ' #metal-color input:not(.hide)')
                    firstColor ? addClass(firstColor, 'selected') : ''
                    firstColor ? addClass(firstColor.parentNode.parentNode, 'selected') : '';
                    firstColor ? firstColor.click() : '';
                }
            }
        }

        if (self.getCurrentVariant()) {
            let diamond = self.getCurrentVariant().diamond,
                color = selectDoc(self.currentMetalColor);

            if (diamond) {
                /**
                 * Update url variant
                 */
                if (!self.isQuickView) {
                    let state = `?v=${diamond.variant}`
                    color ? state += `&color=${color.getAttribute('data-v')}` : '';
                    window.history.pushState({}, 'v', state);

                    self.facebookUrl ? self.facebookShare.setAttribute('href', self.facebookUrl + `?variant=${encodeURIComponent(state)}`) : '';
                    self.emailUrl ? self.emailShare.setAttribute('href', self.emailUrl + `${encodeURIComponent(state)}`) : '';
                }

                /**
                 * Show/Hide variant sizes
                 */
                let allSizes = selectArr(self.main + ' #size-body .size-opt-radio')
                if (!self.isTAH()) {
                    let enabledSizes = selectArr(self.main + ` .size-opt-radio[data-parent="${diamond.variant}"]`);
                    removeClassAll(allSizes, 'show');
                    addClassAll(enabledSizes, 'show');
                    self.reHeight();
                }

                /**
                 * Non jewelry size validation
                 */
                let firstSize;
                if (self.isTAH() && self.verlasIsRing) {
                    firstSize = selectDoc(self.main + ' #size-body .seven.show.size-opt-radio input');
                    self.verlasCurrentSize = size ? size : firstSize
                } else {
                    firstSize = selectDoc(self.main + ' #size-body .show.size-opt-radio:not(.empty) input');
                    self.verlasCurrentSize = self.verlasIsRing ? size : firstSize
                }

                /**
                 * If not size has changed but variant, then reset current size
                 */
                if (pos === 0) {
                    self.sizeSummary.innerText = 'Choose One';
                    removeClassAll(selectArr(self.main + ' #size-body .size-opt-radio'), 'selected');
                    removeClassAll(selectArr(self.main + ' #size-body .size-opt'), 'selected');
                }

                try {
                    size = size ? size : firstSize;
                    if (size) {
                        /**
                         * Set final price(s)
                         */
                        let total = self.isTAH() ? 9900 : size.getAttribute('data-price');
                        selectArr(self.main + ' .pdp-price').map(price => {
                            price.innerHTML = '$' + formatMoney(total, 0)
                        })

                        /**
                         * Update affirm option
                         */
                        selectDoc(self.main + ' .affirm-as-low-as').setAttribute('data-amount', size.getAttribute('data-price'));
                        affirm.ui.refresh();
                    }
                } catch (e) {
                }

                if (!self.isTAH() && size) {
                    ajax('GET', "/products/" + size.getAttribute('data-handle'))
                        .then(function (response) {
                            let htmlData = JSON.parse(response);
                            if (htmlData.status !== undefined) {
                                if (htmlData.status === 200) {
                                    self.hiddenContainer.innerHTML = htmlData.response;
                                    let metafields = selectDoc(`#size-${size.getAttribute('data-id')}`, self.hiddenContainer),
                                        sizeDiamond = JSON.parse(metafields.getAttribute('data-metafields').replace(/=>/g, ':'));
                                    self.hiddenContainer.innerHTML = '';
                                    self.updateDynamicFields({
                                        ...sizeDiamond,
                                        "raw_material": sizeDiamond.raw_materials_cost,
                                        "labor": sizeDiamond.labor_cost,
                                        "duty": sizeDiamond.warehouse_cost,
                                        "retailer": sizeDiamond.retailer_price,
                                        "designer": sizeDiamond.designer_price,
                                        "margin": sizeDiamond.margin,
                                        "total": sizeDiamond.verlas_price,
                                    });
                                    self.reHeight()
                                }
                            }
                        })
                }

                /**
                 * Setup slider & iframe (one time only)
                 */
                if (!self.sliderInitiated || self.isQuickView) {
                    if (self.slides.length >= 1) {
                        self.glideSlider = initSliderPDP('#product-images-slider', {
                            perView: 1,
                            type: 'slider',
                            rewind: true,
                            bound: true
                        }, false, self.viewOnHandSlider, self);
                    } else {
                        self.slidesControls.style.display = 'none';
                    }
                    self.sliderInitiated = true;
                    self.updateIFrames(diamond);
                    addClass(self.sliderImages, 'show')
                } else {
                    let isHandActive = selectDoc(self.main + ' #slider .glide__slide--active #hand3d');
                    /**
                     * Move slider to first slide
                     */
                    if (!isHandActive) {
                        self.glideSlider ? self.glideSlider.go('<<') : ''
                    }
                }
            }
        }
    }

    /**
     * On variant change keep dynamic specs data up to date
     * @param diamond
     */
    updateDynamicFields(diamond) {
        let self = this;

        /**
         * True cost module
         */
        let produce = 0,
            found = 0;

        if (!diamond) {
            if (selectDoc('#set-true-cost')) {
                diamond = {
                    "raw_material": selectDoc('input#set-raw_materials_cost').value,
                    "labor": selectDoc('input#set-labor_cost').value,
                    "duty": selectDoc('input#set-warehouse_cost').value,
                    "produce": selectDoc('input#set-verlas_cost').value,
                    "price": selectDoc('input#set-verlas_price').value,
                    "retailer": selectDoc('input#set-retailer_price').value,
                    "designer": selectDoc('input#set-designer_price').value
                };
            }
        }

        if (diamond) {
            self.trueCostProps.map((trueCostProp, index) => {
                selectArr(`#pdp .${trueCostProp}`).map(text => {
                    let prop = self.trueCostPropsValues[index];
                    if (diamond[prop]) {
                        found++;
                        text.innerText = '$' + formatMoney(`${diamond[prop]}00`, 0);
                        produce += parseFloat(diamond[prop]);
                    } else {
                        if (prop === 'produce' && produce > 0) {
                            found++;
                            text.innerText = '$' + formatMoney(produce.toString() + '00', 0)
                        }
                        if (prop === 'price') {
                            found++;
                            text.innerText = selectDoc(self.main + ' .pdp-price').innerText
                        }
                    }
                });
            });
        }

        if (self.trueCostModule) {
            self.trueCostModule.style.display = (self.trueCostModule && found > 1) ? 'flex' : 'none';
        }

        /**
         * Dynamic specs
         */
        found = 'none';
        self.dynamicProps.map((dynamicProp, index) => {
            selectArr(`#pdp ${self.main} #${dynamicProp}`).map(value => {
                if (!diamond) {
                    value.style.display = 'none';
                } else {
                    if (diamond[self.dynamicProps[index]]) {
                        found = 'block'
                        let p = selectDoc('p', value);
                        p.innerText = diamond[self.dynamicProps[index]];
                        value.style.display = 'block';
                    } else {
                        value.style.display = 'none';
                    }
                }
            });
        });
        self.dynamicModule ? self.dynamicModule.style.display = found : '';
    }

    /**
     * Check browser url params and search for variant
     */
    checkVariantUrl() {
        let self = this;
        let params = new URL(document.URL).searchParams,
            status = true,
            colorParam = params.get('color') ? params.get('color') : 'white-gold';

        if (params.get('v')) {
            let curV = self.diamonds.find(diamond => diamond.variant === params.get('variant'))
            if (curV) {
                let clarity = selectDoc(self.main + ` #diamond-clarity input[data-v="${curV.clarity}"]`)
                clarity ? addClass(clarity, 'selected') : (status = false);
                clarity ? addClass(clarity.parentNode.parentNode, 'selected') : '';

                let carat = selectDoc(self.main + ` #diamond-carat input[data-v="${curV.weight}"]`)
                carat ? addClass(carat, 'selected') : (status = false);
                carat ? addClass(carat.parentNode.parentNode, 'selected') : '';

                let metal = selectDoc(self.main + ` #metal-gold input[data-v="${curV.metal}"]`)
                metal ? addClass(metal, 'selected') : (status = false);
                metal ? addClass(metal.parentNode.parentNode, 'selected') : '';

                let color = selectDoc(self.main + ` #metal-color input[data-v="${colorParam}"]`)
                color ? addClass(color, 'selected') : (status = false);
                color ? addClass(color.parentNode.parentNode, 'selected') : '';
                color ? color.click() : '';
            } else {
                status = false;
            }
        } else {
            status = false;
        }

        if (params.get('master')) {
            let realLink = selectDoc(self.main + ' .tah-real-product a');
            if (realLink) {
                realLink.click();
            }
        }

        return status;
    }

    /**
     * Check if metal is platinum type
     * @param metal
     * @returns {boolean}
     */
    isPlatinum(metal) {
        let platinums = [
            'Platinum', 'platinum', 'Pt', 'pt'
        ]
        return platinums.includes(metal);
    }

    /**
     * Check if product is Try-At-Home
     * @returns {boolean}
     */
    isTAH() {
        let self = this;
        let tahs = [
            'Try-At-Home', 'Try At Home',
            'Try at home', 'try at home',
            'Try-at-home', 'try-at-home',
            'tah', 'TAH'
        ]
        return tahs.includes(self.type);
    }

    /**
     *
     * Add to try at home kit methods
     *
     */
    initAddToTah(atcCta) {
        let self = this;
        if (atcCta) {
            event(atcCta, 'click', function (e) {
                e.preventDefault()
                if (!self.addingtoCart) {
                    let form = selectDoc(self.main + ` form.shopify-product-form`),
                        formData = serialize(form);

                    if (self.verlasCurrentSize) {
                        formData.properties.band_size = self.verlasCurrentSize.getAttribute('data-title')
                    }

                    //Validate required inputs
                    if (inputEmpty(formData.properties['diamond_code']) ||
                        inputEmpty(formData.handle) ||
                        inputEmpty(formData.id) ||
                        inputEmpty(formData.properties['metal_code']) ||
                        (inputEmpty(formData.properties['band_size']) && self.verlasIsRing)) {
                        self.tabSize.classList.add('error')
                        if (self.productForm) {
                            self.productForm.scrollIntoView();
                        }
                    } else {
                        MiniCart.toggleOverlay()
                        self.addingtoCart = true;
                        atcCta.classList.add('atc--inactive')

                        formData.properties['isTah'] = true;
                        formData.properties['handle'] = formData.handle;
                        new Promise(resolve => {
                            ajax('GET', "/cart.js")
                                .then(function (response) {
                                    resolve(response);
                                });
                        }).then(function (response) {
                            response = JSON.parse(response);
                            if (response.status === 200) {
                                let cartData = JSON.parse(response.response);
                                ajax('GET', "/products/" + formData.handle + ".js")
                                    .then(function (response) {
                                        let productData = JSON.parse(response);
                                        if (productData.status !== undefined) {
                                            if (productData.status === 200) {
                                                let product = JSON.parse(productData.response);

                                                /**
                                                 * Cart is empty
                                                 */
                                                if (cartData.items.length < 1) {
                                                    let b3 = product.variants.find(variant => (variant.title.replaceAll(' ', '')) === 'Bundle3')
                                                    if (b3) {
                                                        formData.id = b3.id;
                                                        addCartItemData(JSON.stringify(formData), {
                                                            'name': product.title,
                                                            'id': formData.id,
                                                            'price': '$99',
                                                            'quantity': 1
                                                        }).then(function (response) {
                                                            atcCta.classList.remove('atc--inactive')
                                                            self.addingtoCart = false;
                                                            MiniCart.redirect()
                                                        })
                                                    }
                                                } else {
                                                    let tahCount = 0,
                                                        line = 1,
                                                        tahHandles = [];
                                                    cartData.items.map(item => {
                                                        if (item.properties) {
                                                            if (item.properties.isTah) {
                                                                tahCount++
                                                                tahHandles.push({
                                                                    properties: item.properties,
                                                                    id: item.id,
                                                                    line: line
                                                                })
                                                            }
                                                        }
                                                        line++;
                                                    });

                                                    if (tahCount >= 3) {
                                                        atcCta.classList.remove('atc--inactive')
                                                        self.addingtoCart = false;
                                                        notify('Oops!',
                                                            `You already have <strong>3</strong> pieces in your kit. \n Please remove one from your kit before adding.`,
                                                            'Review My Kit',
                                                            '/cart')
                                                    } else {
                                                        switch (tahCount) {
                                                            case 1:
                                                                tahHandles[0].bundle = 'Bundle2';
                                                                break;
                                                            case 2:
                                                                tahHandles[0].bundle = 'Bundle1';
                                                                tahHandles[1].bundle = 'Bundle1';
                                                                break;
                                                            default:
                                                                break
                                                        }

                                                        self.processBundles(tahCount, product, formData, tahHandles, atcCta);
                                                    }
                                                }
                                            }
                                        }
                                    })
                            } else {
                                console.log('Error fetching cart products data.');
                            }
                        })
                    }
                }
            })
        }
    }

    /**
     * Try-at-Home logic to add to cart bundle package
     * @param tahCount
     * @param product
     * @param formData
     * @param tahHandles
     * @param atcCta
     */
    processBundles(tahCount, product, formData, tahHandles, atcCta) {
        let self = this;

        const addCurrentProduct = (prod) => {
            if (prod) {
                let b = prod.variants.find(variant => (variant.title.replaceAll(' ', '')) === (tahCount < 1 ? 'Bundle3' : 'Bundle1'))
                if (b) {
                    formData.id = b.id;
                    addCartItemData(JSON.stringify(formData), {
                        'name': prod.title,
                        'id': formData.id,
                        'price': '$99',
                        'quantity': 1
                    }).then(function (response) {
                        atcCta.classList.remove('atc--inactive');
                        MiniCart.redirect()
                        self.addingtoCart = false;
                    })
                }
            } else {
                atcCta.classList.remove('atc--inactive')
                MiniCart.redirect()
                self.addingtoCart = false;
            }
        }

        const addExtraProduct = (tahHandle, callback, args) => {
            //Re-add item to cart
            ajax('GET', "/products/" + tahHandle.properties.handle + ".js")
                .then(function (response) {
                    let productData = JSON.parse(response);
                    if (productData.status !== undefined) {
                        if (productData.status === 200) {
                            let subProduct = JSON.parse(productData.response),
                                bundle = subProduct.variants.find(variant => (variant.title.replaceAll(' ', '')) === tahHandle.bundle)
                            if (bundle) {
                                let formData1 = {
                                    properties: tahHandle.properties,
                                    id: bundle.id
                                }
                                addCartItemData(JSON.stringify(formData1), {
                                    'name': subProduct.title,
                                    'id': formData1.id,
                                    'price': '$99',
                                    'quantity': 1
                                }).then(function (response) {
                                    callback.apply(this, args)
                                })
                            }
                        }
                    }
                })
        }

        if (tahCount < 1) {
            addCurrentProduct(product)
        } else {
            if (tahCount === 1) {
                removeCartItem((tahHandles[0].line)).then(function (response) {
                    addExtraProduct(tahHandles[0], addCurrentProduct, [product])
                })
            } else {
                if (tahCount === 2) {
                    removeCartItem((tahHandles[0].line)).then(function (response) {
                        removeCartItem((tahHandles[1].line - 1)).then(function (response) {
                            addExtraProduct(tahHandles[0], addExtraProduct, [tahHandles[1], addCurrentProduct, [product]])
                        })
                    })
                }
            }
        }
    }

    /**
     * Go back logic
     */
    initGoBackButton() {
        let self = this;
        let button = selectDoc(self.main + ' #pdp-go-back'),
            pdpReferrer = localStorage.getItem('pdpReferrer');

        if (document.referrer) {
            let currentBaseUrl = window.location.hostname + window.location.pathname;
            if (!document.referrer.includes(currentBaseUrl) && document.referrer.includes('verlas.com')) {
                pdpReferrer = document.referrer;
                localStorage.setItem('pdpReferrer', pdpReferrer);
            } else {
                if (!document.referrer.includes('verlas.com')) {
                    pdpReferrer = '';
                    localStorage.setItem('pdpReferrer', pdpReferrer);
                    if (button) {
                        button.parentNode.removeChild(button);
                        button = null;
                    }
                }
            }
        }

        if (button) {
            event(button, 'click', function () {
                if (pdpReferrer) {
                    button.style.opacity = '0.5';
                    button.disabled = true;
                    window.location.href = pdpReferrer;
                }
            })
        }

        window.onpopstate = function (e) {
            // if the document.referer is verlas.com
            if (e.state) {
                if (pdpReferrer) {
                    window.location.href = pdpReferrer
                }
            }
        }
    }

    /**
     * Events to change hand iframe skin color
     */
    initSkinColor() {
        let self = this;
        if (self.skinColor) {
            self.skinColorBtns.map(btn => {
                event(btn, 'click', function () {
                    addClassAll(self.skinColorBtns, 'open')
                    removeClassAll(self.skinColorBtns, 'active')
                    btn.classList.add('active')
                    self.updateIFrames(null, btn.id, 'hand')
                    $(btn).attr('aria-pressed', 'true');
                    $(btn).prevAll("button").attr('aria-pressed', 'false');
                    $(btn).nextAll("button").attr('aria-pressed', 'false');
                    $(btn).prevAll("label").removeClass("d-block").addClass("d-none")
                    $(btn).nextAll("label").removeClass("d-block").addClass("d-none")
                    $(btn).next("label").addClass("d-none").addClass("d-block")
                })
            })
        }
    }

    /**
     * Quick shop top fixed component
     */
    initQuickShop() {
        let self = this;
        if (self.quickShop) {
            event(window, 'scroll', function () {
                let limit = 600, top = '-105px';
                if (self.pageContainer.getBoundingClientRect().width < 768) {
                    limit = 300
                    top = '-200px';
                }

                if (window.scrollY > limit) {
                    addClass(self.quickShop, 'active')
                    self.quickShop.style.top = 0
                } else {
                    removeClass(self.quickShop, 'active')
                    self.quickShop.style.top = top
                }
            })
        }

    }

    /**
     * On metal color change update quick shop thumbnail
     * @param color
     */
    updateQuickShopImage(color) {
        let self = this;
        let found = false,
            firstImg = null;

        color = color ? color : 'white';
        removeClassAll(self.quickShopImages, 'active')
        self.quickShopImages.map((image, index) => {
            if (index === 0) {
                firstImg = image
            }

            if (image.id == color) {
                image.classList.add('active')
                found = true;
            }
        })

        if (!found) {
            firstImg ? firstImg.classList.add('active') : ''
        }
    }
}
